import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Badge from '@material-ui/core/Badge';
import clsx from 'clsx';
const gradient = (theme) => `linear-gradient(90deg, ${fade(theme.palette.primary.main, 0.5)} 28%, ${theme.palette.error.main} 72.91%)`;
const useStyles = makeStyles((theme) => createStyles({
    root: {
        height: 6,
        borderRadius: 6,
        padding: 0,
        background: theme.palette.grey[100],
    },
    bar: {
        height: 6,
        borderRadius: 6,
        background: gradient(theme),
        width: ({ value }) => `${value}%`,
    },
    static: {
        '&': {
            background: gradient(theme),
        },
        '& $bar': {
            background: theme.palette.grey[100],
            width: ({ value }) => `${100 - value}%`,
            marginLeft: ({ value }) => `${value}%`,
        },
    },
    badgeRoot: {
        display: 'flex',
    },
    badge: {
        width: ({ customText }) => (customText ? 'auto' : 26),
        height: 26,
        borderRadius: 13,
        top: 3,
        right: ({ value }) => `${100 - value}%`,
    },
}), { name: 'TpTrustLinearProgress' });
/**
 * A linear progress bar used for the user Trust inside together price.
 */
const TrustLinearProgress = ({ variant = 'default', value, customText, }) => {
    const classes = useStyles({ value, customText });
    return (React.createElement("div", { className: clsx(classes.root, {
            [classes.static]: variant === 'static',
        }) },
        React.createElement(Badge, { color: 'primary', max: 100, badgeContent: customText || value, component: 'div', classes: {
                root: classes.badgeRoot,
                badge: classes.badge,
            } },
            React.createElement("div", { className: classes.bar }))));
};
export default TrustLinearProgress;
